import { all } from 'redux-saga/effects';
import '@babel/polyfill';
import agencySagas from './agency';
import navigationSagas from './navigation';
import prefillQuotesSagas from './prefillQuotes';

export default function* rootSaga() {
  yield all([...agencySagas, ...navigationSagas, ...prefillQuotesSagas]);
}
